import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceDetailPage.css';

const ServiceDetailPage = ({
  pageTitle,
  breadcrumbLabel,
  lead,
  paragraphs = [],
  benefits = [],
  heroImage,
  ctaText = 'Request a Quote',
  ctaHref = '/contact'
}) => {
  const label = breadcrumbLabel || pageTitle;
  const hasHeroImage = Boolean(heroImage);
  const heroStyle = heroImage
    ? {
        backgroundImage: `linear-gradient(100deg, rgba(7, 20, 46, 0.32), rgba(5, 38, 82, 0.2)), url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    : undefined;

  return (
    <div className="service-detail-page">
      <section className={`service-hero-banner ${hasHeroImage ? 'has-hero-image' : ''}`} style={heroStyle}>
        <div className="service-hero-overlay" />
        <div className="container service-hero-content">
          <h1>{pageTitle}</h1>
          <div className="service-breadcrumb-top">
            <Link to="/">HOME</Link>
            <span>—</span>
            <span>{label}</span>
          </div>
        </div>

        <div className="service-breadcrumb-strip-wrap">
          <div className="service-breadcrumb-strip">
            <div className="container">
              <span>HOME — {label}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container service-content-wrap">
          <h2>{pageTitle}</h2>

          {lead && <p className="service-lead-text">{lead}</p>}

          {paragraphs.map((text, index) => (
            <p key={index}>{text}</p>
          ))}

          {benefits.length > 0 && (
            <div className="service-benefits-block">
              <h3>
                <span className="service-benefits-line" />
                Key Benefits:
              </h3>
              <ul>
                {benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>
          )}

          <Link to={ctaHref} className="btn btn-primary service-page-cta">
            {ctaText}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetailPage;